let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("5REj3")).then(() => parcelRequire('2lmAK'));